function CustomEvent (event, params) {
  params = params || { bubbles: false, cancelable: false, detail: null }
  const evt = document.createEvent('CustomEvent')
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
  return evt
}
if (typeof window.CustomEvent !== 'function') {
  window.CustomEvent = CustomEvent
}

const TTI_STATE = { value: '', isTTI: false }

export const setTTIStage = (value, isTTI = false) => {
  if (!value || TTI_STATE.isTTI) return
  TTI_STATE.value = value
  TTI_STATE.isTTI = isTTI
  window.dispatchEvent(new CustomEvent('ttistagechange', { detail: TTI_STATE }))
}
